import api from '@/libs/axios'


export default {
  async create(payload) {
    const response = await api.post('/admin/ai-prompts', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/ai-prompts', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/ai-prompts', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/ai-prompts', {
      params,
    })
    return response.data.data
  },
  async get(params) {
    let response = await api.get('/admin/ai-prompts/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
